import styled from '@rsos/theme/styled';

export const IconButton = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: ${({ theme, active }) =>
    active ? theme.colors.highlights : theme.colors.background};
  border-radius: 5px;
  border: 1px solid
    ${({ theme, active }) =>
      active ? theme.colors.primaryBase : theme.colors.heavyLineOutline};
  transition: background-color 0.3s;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;
